import * as ReportsPaths from './reports';
import * as IntakePaths from './intake';
import * as AutomatedInsightsPaths from './automated-insights';

export const Paths = {
  reports: { ...ReportsPaths },
  intake: { ...IntakePaths },
  automatedInsights: { ...AutomatedInsightsPaths },
};
